import { Link } from 'react-router-dom';

import {
  Drawer as BaseDrawer,
  Box,
  DrawerProps,
  PaperProps,
  styled,
  Toolbar,
  Typography,
  Icon,
  useTheme,
} from '@sbv-clients/ui-shared';

import SidebarNav from './sidebar-nav/sidebar-nav';
import { SideBarMenuItem } from './types';

const Drawer = styled(BaseDrawer)`
  .MuiPaper-root {
    border-right: 0;
    background-color: ${(props) => props.theme.sidebar.background};
  }

  .toolbar {
    background-color: ${(props) => props.theme.sidebar.background};
  }
`;

export const Sidebar = ({
  title,
  variant = 'permanent',
  PaperProps,
  open,
  onClose,
  items = [],
}: {
  title?: string;
  PaperProps?: Partial<PaperProps>;
  variant?: DrawerProps['variant'];
  open?: boolean;
  onClose?: () => void;
  items?: SideBarMenuItem[];
}) => {
  const theme = useTheme();

  return (
    <Drawer
      variant={variant}
      PaperProps={PaperProps}
      open={open}
      onClose={onClose}
    >
      <Box>
        <Toolbar className="toolbar">
          <Box
            width="100%"
            display="flex"
            justifyContent={'space-between'}
            alignItems={'center'}
            sx={{
              paddingLeft: '20px',
              paddingRight: '12px',
              paddingTop: '20px',
            }}
          >
            <Link to="/">
              <Icon
                name="LogoSVG"
                customSizes={{ width: '150px', height: '46px' }}
              />
              {title && (
                <Typography variant="h4" color="primary">
                  {title}
                </Typography>
              )}
            </Link>
          </Box>
        </Toolbar>
        <Box
          sx={{
            height: '3px',
            marginX: '20px',
            marginTop: '12px',
            marginBottom: '12px',
            borderRadius: '2px',
            background: `linear-gradient(90deg, ${theme.colors.gold}, transparent)`,
          }}
        />
        <SidebarNav items={items} />
      </Box>
    </Drawer>
  );
};
